import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import '../../../../assets/stylesheets/Dialogs/QuitMemberClub.scss';
import { openDialog } from '../../../../store/actionCreators/dialog';
import { Form } from 'react-bootstrap';

const CreateClubCode = () => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const [code, setCode] = useState('');

    const createClub = () => {
        dispatch(openDialog('createClub', { code }));
    }

    return (
        <div className={`fieldSet`}>
            <Form.Group className={`field`}>
                <Form.Label className={`label`}>
                    {t('codeForClubCreation')}
                </Form.Label>
                <Form.Control
                    type="number"
                    defaultValue={code}
                    onChange={e => setCode(e.target.value)}
                />
            </Form.Group>
            <div className={`dialogConfirmBox`}>
                <button className="primary" disabled={!code} onClick={createClub}>{t('createAClub')}</button>
            </div>
        </div>
    );
};

export default CreateClubCode;
